import { Translation } from '../types';

export const pt: Translation = {
  common: {
    loading: 'A carregar...',
    error: 'Erro',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Fechar',
    search: 'Pesquisar',
    reload: 'Recarregar',
    logout: 'Terminar Sessão',
    dashboard: 'Painel',
    products: 'Produtos',
    settings: 'Definições',
    language: 'Idioma',
    businessHours: 'Horário de Funcionamento',
    back: 'Voltar',
    selectAll: 'Selecionar Tudo',
    deselectAll: 'Desmarcar Tudo',
    success: 'Sucesso',
    selected: 'Selecionado',
    confirm: 'Confirmar',
    required: 'Obrigatório',
    requiredMarker: '*',
    previous: 'Anterior',
    next: 'Seguinte',
    allRightsReserved: 'Todos os direitos reservados.',
  },
  auth: {
    login: 'Login',
    email: 'Endereço de E-mail',
    password: 'Palavra-passe',
    loginButton: 'Entrar',
    loggingIn: 'A entrar...',
    loginSuccess: 'Login efetuado com sucesso',
    loginError: 'E-mail ou palavra-passe incorretos',
    invalidEmail: 'Por favor, insira um endereço de e-mail válido',
    requiredFields: 'Por favor, insira o e-mail e a palavra-passe',
    demoAccount: 'Conta de Demonstração:',
    loginDescription: 'Insira os dados da sua conta para entrar',
    welcomeMessage: 'Bem-vindo ao sistema de encomendas para parceiros',
    // Registration
    register: 'Registar',
    createAccount: 'Criar Conta',
    confirmPassword: 'Confirmar Palavra-passe',
    passwordRequirements: 'A palavra-passe deve ter pelo menos 8 caracteres com maiúsculas, minúsculas, números e caracteres especiais',
    passwordsDoNotMatch: 'As palavras-passe não coincidem',
    registrationSuccess: 'Registo efetuado com sucesso',
    registrationDescription: 'Registe-se para uma conta empresarial',
    alreadyHaveAccount: 'Já tem uma conta?',
    signIn: 'Entrar',
    dontHaveAccount: "Não tem uma conta?",
    creatingAccount: 'A criar conta...',
    registrationNote: 'Nota:',
    registrationNotePoints: {
      erpLinking: 'Se já tiver uma conta empresarial, o seu e-mail será associado automaticamente',
      companyEmail: 'Por favor, utilize o endereço de e-mail da sua empresa para o registo',
      contactSupport: 'Contacte o suporte se precisar de ajuda com o registo'
    },
    b2bUsers: 'Utilizadores de Conta Empresarial:',
    registeredEmail: 'Endereço de e-mail registado',
    registeredPassword: 'Palavra-passe definida durante o registo',
    b2bCustomerRequired: 'Este endereço de e-mail não está registado como cliente empresarial. Por favor, contacte as vendas para estabelecer uma relação comercial primeiro.',
    b2bVerificationError: 'Não foi possível verificar o estatuto de cliente empresarial. Por favor, contacte o suporte.',
    // Password Reset
    passwordReset: 'Redefinição de Palavra-passe',
    passwordResetDescription: 'Insira o seu endereço de e-mail para obter uma palavra-passe temporária',
    getTemporaryPassword: 'Obter Palavra-passe Temporária',
    processing: 'A processar...',
    passwordResetComplete: 'Redefinição de Palavra-passe Concluída',
    temporaryPasswordGenerated: 'Foi gerada uma palavra-passe temporária',
    temporaryPassword: 'Palavra-passe Temporária',
    backToLogin: 'Voltar ao Login',
    securityNotice: 'Aviso de Segurança:',
    securityNotePoints: {
      keepSecret: 'Não partilhe a palavra-passe temporária com ninguém',
      changeAfterLogin: 'Certifique-se de alterar a sua palavra-passe após entrar',
      expires24Hours: 'A palavra-passe temporária expira após 24 horas'
    },
    resetNote: 'Nota:',
    resetNotePoints: {
      registeredEmail: 'Insira o seu endereço de e-mail registado',
      passwordDisplayed: 'A palavra-passe temporária será exibida no ecrã',
      changeRequired: 'É necessária a alteração da palavra-passe após o login'
    },
    copied: 'Copiado',
    copySuccessMessage: 'Palavra-passe temporária copiada para a área de transferência.',
    forgotPassword: 'Esqueceu-se da palavra-passe?',
    // Password Reset Email Request
    sendResetLink: 'Enviar Link de Redefinição',
    sendingEmail: 'A enviar e-mail...',
    emailSent: 'E-mail Enviado',
    emailSentMessage: 'Se este endereço de e-mail existir no nosso sistema, receberá um link de redefinição de palavra-passe em breve.',
    emailNotSent: 'E-mail não enviado',
    emailSentInfo: 'Verifique a sua caixa de entrada e a pasta de spam',
    checkEmail: 'Verificar E-mail',
    emailInstructions: 'As instruções de redefinição de palavra-passe foram enviadas',
    nextSteps: 'Próximos Passos:',
    nextStepsList: {
      checkInbox: 'Verifique a sua caixa de entrada e a pasta de spam',
      clickLink: 'Clique no link de redefinição no e-mail',
      linkExpires: 'O link expira em 24 horas',
      contactSupport: 'Contacte o suporte se não receber o e-mail',
      rateLimitInfo: 'Limitado a 3 pedidos por hora'
    },
    // Password Reset Completion
    resetLinkSent: 'Link de Redefinição Enviado',
    resetSuccess: 'Palavra-passe Redefinida com Sucesso',
    passwordUpdated: 'Palavra-passe Atualizada',
    passwordUpdateMessage: 'A sua palavra-passe foi atualizada com sucesso. Pode agora entrar com a nova palavra-passe.',
    loginWithNewPassword: 'Entrar com a Nova Palavra-passe',
    // Reset Token Page
    resetToken: 'Redefinir Palavra-passe',
    invalidToken: 'Token de redefinição inválido',
    expiredToken: 'O token de redefinição expirou',
    tokenValid: 'O token de redefinição é válido',
    newPassword: 'Nova Palavra-passe',
    confirmNewPassword: 'Confirmar Nova Palavra-passe',
    updatePassword: 'Atualizar Palavra-passe',
    updatingPassword: 'A atualizar palavra-passe...',
    passwordMismatch: 'As palavras-passe não coincidem',
    resetInstructions: 'Insira a sua nova palavra-passe para concluir a redefinição',
  },
  accountInfo: {
    title: 'Informação da Conta',
    loading: 'A carregar informação da conta...',
    error: 'Erro',
    errorMessage: 'Falha ao obter informação da conta',
    back: 'Voltar',
    basicInfo: 'Informação Básica',
    name: 'Nome',
    email: 'Endereço de E-mail',
    contactId: 'ID de Cliente Knitido',
    contactNumber: 'Número de Contacto',
    noInfo: 'Sem informação',
    companyInfo: 'Informação da Empresa',
    company: 'Nome da Empresa',
    position: 'Cargo',
    vatId: 'NIF / N.º IVA',
    billingAddress: 'Endereço de Faturação',
    deliveryAddress: 'Endereço de Entrega',
    addressInfo: 'Informação de Morada',
    billingDescription: 'Endereço para faturas e documentos contratuais',
    deliveryDescription: 'Endereço padrão para envio de produtos',
    sameAsBilling: '※ Igual ao endereço de faturação',
    sameAsDelivery: '※ Igual ao endereço de entrega',
    companyName: 'Nome da Empresa',
    contactPerson: 'Pessoa de Contacto',
    address: 'Morada',
    phoneNumber: 'Número de Telefone',
    billingUsage: 'Utilizado como destino para faturas, contratos e outros documentos importantes',
    deliveryUsage: 'Utilizado como o endereço de entrega padrão para produtos encomendados',
    alsoUsedForDelivery: 'Também utilizado como destino de entrega',
    accountType: 'Tipo de Conta',
    addressId: 'ID de Endereço',
    // Address editing functionality
    edit: 'Editar',
    editDeliveryAddress: 'Editar Endereço de Entrega',
    editDeliveryDescription: 'Atualize as informações do seu endereço de entrega',
    newDeliveryAddress: 'Adicionar Novo Endereço de Entrega',
    newDeliveryDescription: 'Insira os detalhes para o seu novo endereço de entrega',
    noDeliveryAddress: 'Nenhum endereço de entrega configurado',
    success: 'Sucesso',
    addressUpdated: 'Endereço de entrega atualizado com sucesso',
    updateError: 'Falha ao atualizar endereço de entrega',
    requiredFields: 'Por favor, preencha todos os campos obrigatórios',
    firstName: 'Nome Próprio',
    lastName: 'Apelido',
    streetAddress: 'Morada',
    streetAddress2: 'Morada 2 (Edifício, etc.)',
    city: 'Cidade',
    country: 'País',
    selectCountry: 'Selecionar país...',
    searchCountry: 'Pesquisar país...',
    noCountryFound: 'Nenhum país encontrado.',
    postalCode: 'Código Postal',
    companyNamePlaceholder: 'Insira o nome da empresa',
    firstNamePlaceholder: 'Nome próprio',
    lastNamePlaceholder: 'Apelido',
    streetAddressPlaceholder: 'Insira a morada',
    streetAddress2Placeholder: 'Apartamento, suite, etc.',
    cityPlaceholder: 'Insira a cidade',
    postalCodePlaceholder: 'Insira o código postal',
    billingNotEditable: 'O endereço de faturação não pode ser editado.',
    billingContactSupport: 'Contacte o suporte para alterações.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} endereços de entrega',
    noDeliveryAddresses: 'Nenhum endereço de entrega registado',
    defaultAddress: 'Padrão',
    selectDeliveryAddress: 'Selecionar endereço de entrega',
    addNewAddress: 'Adicionar novo endereço',
    editAddress: 'Editar endereço',
    deleteAddress: 'Eliminar endereço',
    confirmDelete: 'Confirmar eliminação',
    confirmDeleteMessage: 'Tem a certeza de que deseja eliminar este endereço? Esta ação não pode ser desfeita.',
    addressAddedSuccess: 'Endereço de entrega adicionado',
    addressDeletedSuccess: 'Endereço de entrega eliminado',
    deleteError: 'Falha ao eliminar endereço de entrega',
    saving: 'A guardar...',
    cancel: 'Cancelar',
    saveChanges: 'Guardar alterações',
    selectedDeliveryAddress: 'Endereço de entrega selecionado',
  },
  dashboard: {
    title: 'Parceiro Comercial',
    subtitle: 'Sistema de Encomenda de Produtos',
    welcome: 'Bem-vindo,',
    welcomeMessage: 'Bem-vindo ao sistema de encomendas para Parceiros Comerciais. Pode encomendar produtos aqui.',
    productCatalog: 'Catálogo de Produtos',
    productCatalogDesc: 'Navegar e encomendar produtos disponíveis',
    viewProducts: 'Ver Produtos',
    orderHistory: 'Histórico de Encomendas',
    orderHistoryDesc: 'Ver encomendas anteriores (brevemente)',
    accountSettings: 'Definições da Conta',
    accountSettingsDesc: 'Gerir informações da conta (brevemente)',
    comingSoon: 'Brevemente',
    infoTitle: 'Sobre a Utilização',
    orderingInfo: 'Encomenda de Produtos',
    orderingDesc: 'Selecione produtos do catálogo e especifique tamanho e cor. Informação de stock em tempo real disponível.',
    supportInfo: 'Suporte',
    supportDesc: 'Se tiver alguma dúvida, por favor contacte-nos.',
    viewOrderHistory: 'Ver Histórico de Encomendas',
    viewOrders: 'Ver Encomendas',
    accountInfo: 'Informação da Conta',
    accountInfoDesc: 'Ver detalhes da sua conta',
    viewDetails: 'Ver Detalhes',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Segunda-Sexta 9:00 - 15:00 CET',
    bulkImportDesc: 'Importar encomendas de ficheiros Excel/CSV',
    importOrders: 'Importar Encomendas',
  },
  products: {
    title: 'Lista de Produtos',
    subtitle: 'Parceiro Comercial',
    searchPlaceholder: 'Pesquisar por nome do produto ou SKU...',
    productId: 'ID do Produto',
    addToCart: 'Adicionar ao Carrinho',
    selectVariation: 'Selecionar Variação',
    price: 'Preço',
    priceNetNotice: 'Todos os preços são líquidos',
    stock: 'Stock',
    color: 'Cor',
    newProducts: 'Novos Produtos',
    newProductBadge: 'NOVO',
    size: 'Tamanho',
    quantity: 'Quantidade',
    total: 'Total',
    cart: 'Carrinho',
    checkout: 'Finalizar Compra',
    csvMode: 'Modo Rápido CSV',
    csvInfo: 'Dados do produto obtidos de dados CSV',
    csvUploadDate: 'Data de Carregamento CSV:',
    stockNote: '※ A informação de stock é obtida ao selecionar variações do produto',
    noProducts: 'Nenhum produto encontrado',
    noProductsDesc: 'Altere os critérios de pesquisa ou carregue um ficheiro CSV para um desempenho mais rápido.',
    retry: 'Tentar Novamente',
    pagination: 'itens',
    variations: 'variações',
    stockFetchError: 'Erro ao obter stock',
    stockFetchFailed: 'Falha ao obter stock',
    stockFetchFailedDesc: 'Não foi possível obter a informação de stock. O stock do CSV será exibido.',
    stockFetched: 'Informação de stock obtida',
    totalStock: 'Stock total',
    noStockAll: 'Todas as variações têm stock zero',
    noStockData: 'Nenhuns dados de stock retornados',
    stockFetchErrorDesc: 'Ocorreu um erro ao obter a informação de stock',
    selectionError: 'Erro de seleção',
    enterQuantity: 'Por favor insira a quantidade',
    addedToCart: 'Adicionado ao carrinho',
    typesAdded: ' tipos de produtos adicionados',
    addToCartError: 'Erro ao adicionar ao carrinho',
    addToCartErrorDesc: 'Por favor, tente novamente',
    loadingStock: 'A carregar informação de stock',
    csvDataInfo: 'A exibir informação de dados CSV (não níveis de stock reais)',
    invalidDataFormat: 'O formato dos dados do produto é inválido',
    loadFailed: 'Falha ao carregar dados do produto',
    csvUploadComplete: 'Carregamento CSV concluído',
    csvLoadedDesc: ' dados de produtos carregados. A informação de stock será obtida ao selecionar produtos.',
    searchTitle: 'Pesquisa de Produtos',
    loadingProducts: 'A carregar dados dos produtos',
    noProductsCsv: 'Nenhum produto encontrado nos dados CSV. Por favor altere os critérios de pesquisa.',
    paginationDisplay: ' exibidos',
    previous: 'Anterior',
    next: 'Seguinte',
    selectionSummary: 'Resumo da Seleção',
    selectedQuantity: 'Quantidade Selecionada',
    items: ' itens',
    viewDetails: 'Ver Detalhes',
    productImage: 'Imagem do Produto',
    correspondingVariations: 'Variações Correspondentes',
    clickToEnlarge: 'Clique para ampliar',
    productIdLabel: 'ID do Produto',
    colorLabel: 'Cor',
    filterByCategory: 'Filtrar por Categoria',
    allProducts: 'Todos os Produtos',
    applyFilters: 'Aplicar Filtros',
    clearFilters: 'Limpar Filtros',
    filters: 'Filtros',
    clearAll: 'Limpar tudo',
  },
  categories: {
    category_21: 'Meias com Dedos',
    category_23: 'Sem Categoria',
    category_24: 'Body Wear',
    category_29: 'Produtos B2B',
  },
  productDetail: {
    title: 'Detalhes do Produto',
    backToProducts: 'Voltar aos Produtos',
    productNotFound: 'Produto Não Encontrado',
    productNotFoundDesc: 'O produto especificado não existe ou foi eliminado.',
    loading: 'A carregar produto...',
    imageLoadError: 'Falha ao carregar imagens',
    noImages: 'Sem imagens disponíveis',
    productDescription: 'Descrição do Produto',
    colors: 'Cores',
    sizes: 'Tamanhos',
    colorCount: 'cores',
    sizeCount: 'tamanhos',
    variationCount: 'variações',
    selectVariation: 'Selecionar Variações',
    descriptionLanguageNote: '※ As descrições dos produtos estão disponíveis apenas em Inglês ou Alemão',
  },
  colors: {
    schwarz: 'Preto',
    weiß: 'Branco',
    grau: 'Cinzento',
    rot: 'Vermelho',
    blau: 'Azul',
    grün: 'Verde',
    gelb: 'Amarelo',
    rosa: 'Rosa',
    lila: 'Roxo',
    braun: 'Castanho',
    orange: 'Laranja',
    beige: 'Bege',
    navy: 'Azul Marinho',
    dunkelblau: 'Azul Escuro',
    hellblau: 'Azul Claro',
    dunkelgrau: 'Cinzento Escuro',
    hellgrau: 'Cinzento Claro',
    bordeaux: 'Bordeaux',
    türkis: 'Turquesa',
    khaki: 'Caqui',
    mint: 'Menta',
    violett: 'Violeta',
    anthrazit: 'Antracite',
    blaugrau: 'Azul Acinzentado',
    burgunderrot: 'Borgonha',
    elfenbein: 'Marfim',
    karminrot: 'Carmim',
    neongrün: 'Verde Néon',
    gelbgrün: 'Verde Amarelado',
    pistazie: 'Pistacho',
    // English color names (used in Product ID 237 etc.)
    blue: 'Azul',
    ivory: 'Marfim',
    green: 'Verde',
    gold: 'Dourado',
    red: 'Vermelho',
  },
  checkout: {
    title: 'Finalizar Compra',
    cartReview: 'Rever Encomenda',
    orderSummary: 'Resumo da Encomenda',
    shippingInfo: 'Informação de Envio',
    billingInfo: 'Informação de Faturação',
    orderNotes: 'Notas da Encomenda',
    orderNotesPlaceholder: 'Pedidos especiais ou notas...',
    contactPerson: 'Pessoa de Contacto',
    phoneNumber: 'Número de Telefone',
    email: 'Endereço de E-mail',
    company: 'Empresa',
    address: 'Morada',
    city: 'Cidade',
    postalCode: 'Código Postal',
    country: 'País',
    deliveryDate: 'Data de Entrega',
    urgentDelivery: 'Entrega Expresso (3-5 dias úteis)',
    standardDelivery: 'Entrega Padrão (7-10 dias úteis)',
    placeOrder: 'Confirmar Encomenda',
    backToCart: 'Voltar à Seleção de Produtos',
    requiredField: 'Campo obrigatório',
    orderTotal: 'Total da Encomenda',
    subtotal: 'Subtotal',
    priceNetNotice: 'Todos os preços são líquidos',
    stockReservationNotice: 'A reserva de stock será feita após a confirmação da encomenda.',
    stockCheckError: 'Erro de Verificação de Stock',
    stockCheckErrorDesc: 'Ocorreu um erro durante a verificação de stock. Por favor, tente novamente.',
    shipping: 'Envio',
    shippingCost: 'Custo de Envio',
    tax: 'IVA',
    orderSuccess: 'Encomenda Efetuada com Sucesso',
    orderSuccessMessage: 'A sua encomenda foi submetida com sucesso. Número da encomenda: {orderNumber}',
    orderNumber: 'Número da Encomenda',
    thankYou: 'Obrigado pela sua encomenda!',
    orderConfirmation: 'A sua encomenda foi submetida com sucesso.',
    orderProcessing: 'Após revisão pela nossa equipa, enviaremos uma confirmação da encomenda por e-mail.',
    orderProcessingMessage: 'A sua encomenda foi submetida com sucesso. Após revisão pela nossa equipa, enviaremos uma confirmação da encomenda por e-mail.',
    continueShopping: 'Continuar a Comprar',
    emptyCart: 'O seu carrinho está vazio',
    emptyCartMessage: 'Por favor, adicione produtos ao carrinho para continuar',
    stockWarning: 'Aviso de Stock',
    stockWarningDesc: 'Alguns itens têm stock insuficiente. Por favor, ajuste as quantidades.',
    stockError: 'Erro de Stock',
    stockErrorDesc: 'Existem itens com stock insuficiente. Por favor, ajuste as quantidades.',
    refreshStock: 'Atualizar Stock',
    stockUpdated: 'Stock Atualizado',
    stockUpdatedDesc: 'O stock foi atualizado - {changed} itens alterados',
    stockCheckDesc: 'São exibidos os resultados da comparação com o inventário',
    stockOk: 'Stock OK',
    stockShortage: 'Falta de Stock',
    requestedQty: 'Qtd Solicitada',
    currentStock: 'Stock Atual',
    stockShortageMsg: 'Stock insuficiente. Por favor, ajuste a quantidade.',
    stockIssueWarning: 'A encomenda não pode ser confirmada devido a problemas de stock.',
    stockDataMissing: 'Os dados de stock estão a ser obtidos. Por favor, aguarde um momento.',
    outOfStock: 'Esgotado.',
    maxAvailable: 'Máximo',
    autoRestored: 'Carrinho restaurado',
    autoRestoredDesc: 'Os itens da sua última sessão foram restaurados',
    maxQuantityReached: 'Quantidade máxima de stock atingida.',
    // ERP Contact Search
    contactSearch: 'Pesquisa de Contacto de Cliente',
    contactSearchDesc: 'Insira o endereço de e-mail do encomendador para obter as informações de contacto',
    emailAddress: 'Endereço de E-mail',
    searchButton: 'Pesquisar',
    searching: 'A pesquisar',
    contactFound: 'Contacto Encontrado',
    contactNotFound: 'Contacto Não Encontrado',
    contactId: 'ID de Cliente Knitido',
    companyName: 'Empresa',
    contactPersonLabel: 'Pessoa de Contacto',
    addressesFound: 'Endereços Encontrados',
    addressType: 'Tipo',
    addressBilling: 'Endereço de Faturação',
    addressDelivery: 'Endereço de Entrega',
    vatSourceCompany: 'Info. da Empresa',
    vatSourceBilling: 'Faturação',
    vatSourceDelivery: 'Entrega',
    addressOther: 'Outro',
    addressDetails: 'Morada',
    loadingAddresses: 'A carregar informação de morada...',
    addressRetrieved: 'Informação de morada obtida',
    addressNotFound: 'Informação de morada não encontrada',
    addressNotFoundDesc: 'Nenhuma informação de morada registada. Por favor, insira manualmente.',
    addressError: 'Erro na Obtenção de Morada',
    addressErrorDesc: 'Falha ao obter informação de morada.',
    contactNotConfirmed: 'Contacto de Cliente Não Confirmado',
    contactNotConfirmedDesc: 'Por favor, insira um endereço de e-mail e pesquise o contacto.',
    searchContact: 'Pesquisar Contacto',
    inputError: 'Erro de Entrada',
    inputErrorDesc: 'A informação de envio está incompleta. Por favor, verifique.',
    processing: 'A processar...',
    erpContactSearch: 'Pesquisa de Contacto de Cliente',
    contactSearchError: 'O endereço de e-mail não corresponde a nenhum contacto registado.',
    // Product Images Toggle
    showProductImages: 'Mostrar Imagens dos Produtos',
    showProductImagesDesc: 'Exibir imagens dos produtos para melhor visualização (pode aumentar o tempo de carregamento)',
    // System Registration Info
    systemRegistrationInfo: 'A Sua Informação de Cliente',
    editShippingAddress: 'Editar Endereço de Entrega',
    systemRegistrationInfoDesc: 'A sua informação empresarial registada. Por favor contacte o seu representante se precisar de atualizar os detalhes do endereço de faturação.',
    // Order Summary
    regularPrice: 'Preço de Revenda Regular',
    offeredPrice: 'Preço Ofertado',
    discount: 'Desconto',
    b2bCustomer: 'Cliente B2B',
    pattern: 'Padrão',
    specialPriceApplied: 'Preço especial aplicado',
    customerClassification: 'Classificação de Cliente',
    paymentCondition: 'Termos de Pagamento',
    invoice: 'Fatura (30 dias líquidos)',
    prepayment: 'Pagamento Antecipado',
    paymentMethod: 'Método de Pagamento',
    invoicePayment: 'Pagamento por Fatura',
    estimatedSubtotal: 'Subtotal Estimado',
    estimatedTotal: 'Total Estimado',
    orderSummaryDisclaimer: 'Os preços mostrados aqui são estimativas. Assim que recebermos a sua encomenda, iremos analisá-la e enviar-lhe uma confirmação de encomenda vinculativa com os preços finais, custos de envio e impostos por e-mail.',
    searchError: 'Erro de Pesquisa',
    searchErrorDesc: 'Ocorreu um erro durante a pesquisa de contacto.',
    confirmDeleteItem: 'Remover Item',
    itemDeleted: 'Item removido',
    confirmDeleteItemDesc: 'Tem a certeza de que deseja remover o seguinte item do seu carrinho?',
    deleteConfirm: 'Remover',
    contactNotes: 'Notas de Contacto',
    contactNotesDesc: 'Tem alguma dúvida ou pedido especial? Por favor, informe-nos (opcional)',
    contactNotesLabel: 'Mensagem',
    contactNotesPlaceholder: 'ex.: Questões sobre produtos, requisitos especiais, etc.',
    characters: 'caracteres',
    contactIdLabel: 'ID de Cliente Knitido',
    companyLabel: 'Empresa',
    personLabel: 'Pessoa de Contacto',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Tipo',
    destinationLabel: 'Destino',
    // Shipping Form
    shippingTitle: 'Informação de Envio',
    shippingDesc: 'Insira o endereço de entrega para os produtos',
    companyRequired: 'Empresa *',
    contactPersonRequired: 'Pessoa de Contacto *',
    emailRequired: 'Endereço de E-mail *',
    phoneRequired: 'Número de Telefone *',
    addressRequired: 'Morada 1 *',
    address2: 'Morada 2 (Edifício/Sala)',
    postalCodeRequired: 'Código Postal *',
    cityRequired: 'Cidade *',
    countryRequired: 'País *',
    selectCountry: 'Selecionar País',
    shippingMethodRequired: 'Método de Envio *',
    selectShippingMethod: 'Selecionar Método de Envio',
    urgentDeliveryOption: 'Entrega Expresso (custos adicionais)',
    deliveryNotes: 'Notas de Entrega',
    deliveryNotesPlaceholder: 'Insira preferências de horário de entrega ou outros pedidos',
    standardShipping: 'Envio Padrão (3-5 dias úteis)',
    expressShipping: 'Envio Expresso (1-2 dias úteis)',
    overnightShipping: 'Envio Noturno',
    germany: 'Alemanha',
    austria: 'Áustria',
    switzerland: 'Suíça',
    japan: 'Japão',
    shippingAddressLabel: 'Endereço de Entrega',
    changeDeliveryAddress: 'Alterar Endereço de Entrega',
    selectDeliveryAddress: 'Selecionar Endereço de Entrega',
    // Shipping Cost Details
    freeShipping: 'Envio Grátis',
    shippingError: 'Erro',
    shippingZone: 'Zona de Envio',
    remainingForFreeShipping: 'Faltam {amount} para envio grátis',
    moreForFreeShipping: 'para envio grátis',
    freeShippingProgress: 'Envio grátis em',
    andAboveFreeShipping: 'e superior para envio grátis',
    freeShippingAchieved: 'Envio grátis aplicado',
    threshold: 'e superior',
    nextShippingTier: 'Próximo desconto de envio',
    moreForDiscount: 'mais para',
    shippingSavings: 'poupança no envio',
    orderAmountThreshold: 'e superior para',
    specialRegionNotice: 'Região de envio especial aplicada',
    defaultShippingApplied: 'Taxas de envio padrão aplicadas',
    requestedQuantity: 'Quantidade Solicitada',
    availableQuantity: 'Quantidade Disponível',
    orderSubmitError: 'Erro no pedido',
    orderSubmitErrorDesc: 'Falha ao enviar pedido',
    upload: {
      title: 'Importar Encomenda Excel/CSV',
      description: 'Carregue um ficheiro Excel ou CSV com os dados da sua encomenda',
      dragDropOrClick: 'Arraste e largue o ficheiro aqui ou clique para selecionar',
      dropHere: 'Largue o ficheiro aqui',
      supportedFormats: 'Formatos suportados: Excel (.xlsx, .xls) e CSV (.csv)',
      maxSize: 'Tamanho máximo do ficheiro: {size} MB',
      processFile: 'Processar Ficheiro',
      processing: 'A processar ficheiro...',
      ready: 'Ficheiro pronto para pré-visualização',
      readyDescription: 'O seu ficheiro foi processado com sucesso e está pronto para revisão.',
      preview: 'Mostrar Pré-visualização',
      errors: {
        fileTooLarge: 'O ficheiro é demasiado grande. Tamanho máximo: {size} MB',
        invalidFileType: 'Tipo de ficheiro inválido. Por favor carregue um ficheiro Excel ou CSV',
        uploadFailed: 'Erro ao carregar ficheiro',
      },
    },
    // Loading messages
    loadingPage: 'A carregar página...',
    loadingStock: 'A verificar inventário de produtos...',
    loadingAccount: 'A carregar informação da conta...',
    loadingError: 'Ocorreu um erro...',
    loadingData: 'A carregar dados',
    // Toast messages
    addressRetrievedTitle: 'Informação de morada obtida',
    addressSetAsDelivery: ' endereço definido como destino de entrega.',
    contactFoundDesc: ' foi reconhecido.'
  },
  orderHistory: {
    title: 'Histórico de Encomendas',
    searchPlaceholder: 'Pesquisar por número de encomenda ou SKU...',
    noOrders: 'Nenhuma encomenda encontrada',
    noOrdersFound: 'Nenhuma encomenda correspondente encontrada',
    startShopping: 'Ver Produtos',
    orderItems: 'Itens da Encomenda',
    viewDetails: 'Detalhes',
    reorder: 'Reencomendar',
    orderDate: 'Data da Encomenda',
    orderStatus: 'Estado',
    orderTotal: 'Total da Encomenda',
    // Status translations
    statusPending: 'Pagamento Pendente',
    statusProcessing: 'Em Processamento',
    statusConfirmed: 'Confirmado',
    statusShipped: 'Enviado',
    statusDelivered: 'Entregue',
    statusCancelled: 'Cancelado',
    statusReturned: 'Devolvido',
    statusRefunded: 'Reembolsado',
    statusWarranty: 'Garantia',
    statusExchanged: 'Trocado',
    statusRepair: 'Reparação',
    statusUnknown: 'Desconhecido',
    statusIncomplete: 'Incompleto',
    statusWaitingPayment: 'A Aguardar Pagamento',
    statusInPreparation: 'Em Preparação',
    statusClearedShipping: 'Autorizado para Envio',
    statusBeingShipped: 'A ser Enviado',
    statusOutgoingBooked: 'Saída Agendada',
    statusReturn: 'Devolução',
    // Additional UI elements
    itemCount: 'itens',
    itemCountSingular: 'item',
    refreshButton: 'Atualizar',
    errorFetchingOrders: 'Falha ao obter histórico de encomendas',
    // Payment status features
    paymentStatus: 'Estado do Pagamento',
    markAsPaid: 'Marcar como Pago',
    unmarkAsPaid: 'Desmarcar como Pago',
    paidOn: 'Pago em',
    paymentMarked: 'Pago',
    notPaid: 'Não Pago',
    paymentMarkedSuccess: 'Marcado como pago com sucesso',
    paymentUnmarkedSuccess: 'Marca de pagamento removida',
    paymentUpdateError: 'Falha ao atualizar o estado do pagamento',
    // Payment date dialog
    paymentDateTitle: 'Inserir Informação de Pagamento',
    paymentDateDescription: 'Inserir informação de pagamento para a encomenda {orderNumber}',
    paymentDateLabel: 'Data de Pagamento',
    selectDate: 'Selecionar data',
    paymentDateHelp: 'Selecione a data em que a transferência bancária foi efetuada',
    paymentMethodLabel: 'Método de Pagamento',
    bankTransfer: 'Transferência Bancária',
    invoice: 'Fatura',
    otherPayment: 'Outro',
    paymentReferenceLabel: 'Nome da Transferência / Número de Referência',
    paymentReferencePlaceholder: 'ex., João Silva, Transferência #12345',
    paymentReferenceHelp: 'Insira informações que ajudem a corresponder com os extratos bancários',
    notesLabel: 'Notas',
    notesPlaceholder: 'Insira qualquer informação adicional de pagamento',
    // Filter options
    filterByPaymentStatus: 'Filtrar por Estado de Pagamento',
    allOrders: 'Todas as Encomendas',
    paidOrders: 'Pago',
    unpaidOrders: 'Não Pago',
    // Sorting options
    sortBy: 'Ordenar por',
    sortByDate: 'Data da Encomenda',
    sortByPaymentDate: 'Data de Pagamento',
    sortByAmount: 'Montante',
    sortByStatus: 'Estado',
  },
  orderDetails: {
    title: 'Detalhes da Encomenda',
    notFound: 'Encomenda não encontrada',
    backToHistory: 'Voltar ao Histórico de Encomendas',
    orderDate: 'Data da Encomenda',
    orderItems: 'Itens da Encomenda',
    deliveryStatus: 'Estado da Entrega',
    estimatedDelivery: 'Entrega Estimada',
    deliveredOn: 'Entregue em',
    downloadInvoice: 'Descarregar Fatura',
    statusDelivered: 'Entregue',
    statusShipped: 'Enviado',
    statusConfirmed: 'Confirmado',
    statusCancelled: 'Cancelado',
    errorFetchingDetails: 'Falha ao obter detalhes da encomenda',
  },
  company: {
    name: 'Parceiro Comercial',
    tagline: 'Sistema de Parceiro Comercial',
    copyright: '© 2025 Sistema de Parceiro Comercial. Todos os direitos reservados.',
  },
  footer: {
    phone: 'Telefone',
    email: 'E-mail',
    countries: {
      DE: 'Alemanha',
      AT: 'Áustria',
      CH: 'Suíça',
      FR: 'França',
      IT: 'Itália',
      ES: 'Espanha',
      NL: 'Países Baixos',
      BE: 'Bélgica',
      PL: 'Polónia',
      SE: 'Suécia',
      NO: 'Noruega',
      FI: 'Finlândia',
      DK: 'Dinamarca',
      LT: 'Lituânia',
      LV: 'Letónia',
      EE: 'Estónia',
    },
  },
  cart: {
    newCart: 'Novo Carrinho',
    currentCart: 'Carrinho Atual',
    modified: 'modificado',
    lastSaved: 'Última gravação',
    unsavedChanges: 'alterações não guardadas',
    saveCart: 'Guardar Carrinho',
    loadCart: 'Carregar Carrinho',
    deleteCart: 'Eliminar Carrinho',
    startNewCart: 'Iniciar Novo Carrinho',
    savedCarts: 'Carrinhos Guardados',
    cartSaved: 'Carrinho guardado',
    cartDeleted: 'Carrinho eliminado',
    confirmDeleteCart: 'Eliminar carrinho?\n\nEsta ação não pode ser desfeita.',
    confirmSwitchCart: 'O carrinho atual tem alterações não guardadas.\n\nCarregar outro carrinho fará com que as alterações atuais sejam perdidas.\n\nContinuar?',
    confirmSwitchCartTitle: 'Trocar Carrinho',
    confirmNewCart: 'O carrinho atual tem alterações não guardadas.\n\nIniciar um novo carrinho fará com que as alterações atuais sejam perdidas.\n\nContinuar?',
    confirmNewCartTitle: 'Iniciar Novo Carrinho',
    confirmClearCart: 'Limpar carrinho?\n\n{count} itens serão removidos.\n\nEsta ação não pode ser desfeita.',
    confirmClearCartTitle: 'Limpar Carrinho',
    autoSaved: 'Guardado automaticamente',
    itemsWillBeRemoved: 'itens serão removidos',
    changesWillBeLost: 'alterações serão perdidas',
    continueQuestion: 'Continuar?',
    cartStatus: 'Estado do Carrinho',
    cartName: 'Nome do Carrinho',
    cartNamePlaceholder: 'ex.: Encomenda de fim de mês',
    cartNameRequired: 'Por favor, insira um nome para o carrinho',
    saveCartDescription: 'Dê um nome ao carrinho atual e guarde-o. Pode carregá-lo mais tarde.',
    cancelCart: 'Cancelar Carrinho',
    proceedToCheckout: 'Seguir para Finalização',
    emptyCart: 'O carrinho está vazio',
    erpDown: 'O sistema de pedidos está fora do ar. Tente novamente mais tarde.',
    erpDegraded: 'O sistema está atualmente instável. Os pedidos podem falhar.',
    erpDownSaveHint: 'Guarde o seu carrinho e faça o pedido quando o sistema for restaurado.',
    erpSaveCart: 'Guardar carrinho',
  },
  nav: {
    dashboard: 'Painel',
    products: 'Produtos',
    orderHistory: 'Histórico',
    account: 'Conta',
    bulkImport: 'Importação',
  },
  settings: {
    selectLanguage: 'Selecione um Idioma',
    languagePreferenceSaved: 'A sua preferência será guardada na sua conta para futuras visitas.',
  },
  reorder: {
    allItemsAdded: '{count} itens adicionados ao carrinho',
    partialSuccess: '{added} itens adicionados. {failed} itens não puderam ser adicionados',
    allItemsFailed: 'Falha ao adicionar itens ao carrinho',
    error: 'Ocorreu um erro durante a reencomenda',
    itemDiscontinued: '{name} ({color}/{size}) foi descontinuado',
    itemOutOfStock: '{name} ({color}/{size}) está esgotado',
    partialStock: '{name} ({color}/{size}) apenas {available} disponível(eis)',
    confirmReorder: 'Confirmar Reencomenda',
    confirmReorderMessage: 'Adicionar itens desta encomenda ao seu carrinho?',
    addingToCart: 'A adicionar ao carrinho...',
    checkingStock: 'A verificar stock...',
    checkoutTitle: 'Itens Adicionados ao Carrinho',
    checkoutDescription: '{count} itens foram adicionados ao seu carrinho. Deseja prosseguir para a finalização?',
  },
  bulkImport: {
    instructions: 'Como Importar Encomendas',
    step1: 'Descarregue o ficheiro modelo de encomenda',
    step2: 'Preencha os dados da sua encomenda com SKU e quantidade',
    step3: 'Guarde como ficheiro Excel (.xlsx) ou CSV',
    step4: 'Carregue o ficheiro usando o formulário abaixo',
    step5: 'Reveja e confirme a sua encomenda',
    downloadTemplate: 'Descarregar Modelo',
    downloadExcelTemplate: 'Descarregar Modelo Excel',
    downloadCsvTemplate: 'Descarregar Modelo CSV',
    formatGuide: 'Guia de Formato de Ficheiro',
    requiredColumns: 'Colunas Obrigatórias',
    skuDescription: 'Código SKU do produto',
    quantityDescription: 'Quantidade da encomenda (inteiro positivo)',
    optionalColumns: 'Colunas Opcionais',
    notesDescription: 'Notas internas (ex. nº PO, referência) - apenas para seu registo',
    formatNote: 'A primeira linha deve conter os cabeçalhos das colunas. Os dados começam na segunda linha.',
    parseSuccess: '{count} itens processados com sucesso do ficheiro',
    parseError: 'Erro de Processamento',
    validationError: 'Erros de Validação',
    validationErrorGuidance: 'Por favor, clique no botão "{showPreviewButton}" para rever os detalhes.',
    warnings: 'Avisos',
    itemsParsed: '{count} itens processados com sucesso:',
    andMore: '...e mais {count} itens',
    validationSummary: 'Resumo da Validação',
    duplicateSKUs: 'SKUs duplicados encontrados',
    skuFormat: 'O SKU deve conter apenas letras, números e hífenes',
    quantityRange: 'A quantidade deve estar entre 1 e 9999',
    maxRows: 'Máximo de 1000 linhas permitido',
    rowsSkipped: '{count} linhas foram ignoradas devido a erros',
    previewTitle: 'Pré-visualização da Encomenda',
    previewDescription: 'Reveja e edite os dados da sua encomenda antes de prosseguir',
    proceedToCart: 'Adicionar ao Carrinho',
    // File parsing messages
    fileEmpty: 'O ficheiro está vazio ou não contém dados',
    fileTooManyRows: 'O ficheiro contém demasiadas linhas ({current}). Máximo permitido: {max}',
    invalidRowFormat: 'Formato de linha inválido',
    missingColumns: 'Colunas obrigatórias em falta (SKU e Quantidade)',
    missingSku: 'SKU em falta',
    invalidSkuFormat: 'Formato de SKU inválido: "{sku}" (deve corresponder ao padrão: {pattern})',
    skuTooLong: 'SKU demasiado longo: "{sku}" (máximo 50 caracteres)',
    invalidQuantity: 'Quantidade inválida: "{quantity}" não é um número',
    quantityTooLow: 'Quantidade demasiado baixa: {quantity} (mínimo: {min})',
    quantityTooHigh: 'Quantidade demasiado alta: {quantity} (máximo: {max})',
    notesRequired: 'O campo de notas é obrigatório',
    noValidData: 'Nenhuns dados válidos encontrados. Por favor verifique o formato do seu ficheiro.',
    row: 'Linha {row}: {errors}',
    rowErrors: '...e mais {count} erros',
    duplicateSkuInRows: 'SKU duplicado "{sku}" encontrado nas linhas: {rows}',
    quantityExceedsMax: 'Linha {row}: Quantidade {quantity} excede o máximo permitido ({max})',
    quantityBelowMin: 'Linha {row}: Quantidade {quantity} é inferior ao mínimo necessário ({min})',
    // Validation messages
    unsupportedFileFormat: 'Formato de ficheiro não suportado. Por favor carregue um ficheiro CSV ou Excel.',
    csvParsingErrors: 'Ocorreram erros de processamento CSV',
    failedToParseFile: 'Falha ao processar ficheiro',
    failedToParseExcel: 'Falha ao processar ficheiro Excel',
    failedToReadFile: 'Falha ao ler ficheiro',
    unknownError: 'Ocorreu um erro desconhecido',
    totalRows: 'Total de linhas',
    valid: 'Válido',
    invalid: 'Inválido',
    skipped: 'Ignorado',
    // SKU validation
    skuValidationError: 'Erro de Validação de SKU',
    skuValidationFailed: 'Falha ao validar SKUs. Pode prosseguir, mas alguns itens podem não estar disponíveis.',
    skuNotFound: 'SKU não encontrado na base de dados',
    skusNotFound: '{count} SKUs não encontrados na base de dados',
    itemsHaveInsufficientStock: '{count} itens têm stock insuficiente',
    validatingSKUs: 'A validar itens...',
    unvalidatedChanges: 'Tem alterações não validadas. Por favor revalide antes de adicionar ao carrinho.',
    revalidate: 'Revalidar',
    validating: 'A validar...',
    validationSuccess: 'Todos os itens são válidos',
    validationComplete: 'Validação Concluída',
    validationResultSummary: '{errors} erros, {warnings} avisos encontrados',
    // Table headers
    actions: 'Ações',
    notes: 'Notas',
    // Status filter
    all: 'Todos',
    hasErrors: 'Com Erros',
    // Selection summary
    selected: 'selecionado',
    errors: 'erros',
    // Pagination
    page: 'Página {current} de {total}',
    previous: 'Anterior',
    next: 'Seguinte',
    noResults: 'Sem resultados.',
    // Cart integration
    noValidItems: 'Sem Itens Válidos',
    allItemsHaveErrors: 'Todos os itens têm erros de validação. Por favor corrija-os antes de prosseguir.',
    dataLoadingError: 'Erro de Carregamento de Dados',
    failedToLoadProductData: 'Falha ao carregar dados do produto. Por favor, tente novamente.',
    itemsAddedToCart: '{count} Itens Adicionados ao Carrinho',
    itemsAddedMessage: 'Foram adicionados {count} itens ao carrinho',
    someSkusNotFound: '{count} SKUs não puderam ser encontrados.',
    noItemsAdded: 'Nenhuns Itens Adicionados',
    couldNotFindProducts: 'Não foi possível encontrar produtos correspondentes aos SKUs.',
    errorAddingToCart: 'Erro',
    failedToAddToCart: 'Falha ao adicionar itens ao carrinho. Por favor, tente novamente.',
    addingToCart: 'A adicionar ao carrinho...',
    // File info
    fileSelected: '{name} selecionado para processamento',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Descarregar Modelo',
    templateWillBeImplemented: 'O descarregamento de modelo será implementado na Fase 7',
    // Additional validation
    validationFailed: 'A validação falhou',
    // Template download
    templateDownloaded: 'Modelo descarregado com sucesso',
    templateDownloadError: 'Falha ao descarregar modelo',
    // Template content
    sheetName: 'Encomenda em Massa',
    instructionsSheetName: 'Instruções',
    columnDescriptions: 'Descrições das Colunas:',
    columnHeader: 'Coluna',
    columnRequired: 'Obrigatório',
    columnOptional: 'Opcional',
    columnDescription: 'Descrição',
    templateNotes: 'Notas:',
    templateNote1: 'A primeira linha deve conter os cabeçalhos das colunas exatamente como mostrado',
    templateNote2: 'Os dados começam na linha 2',
    templateNote3: 'O SKU deve corresponder aos códigos de produto existentes no sistema',
    templateNote4: 'A quantidade deve ser um número inteiro positivo entre 1 e 9999',
    templateNote5: 'Máximo de 1000 linhas permitido por ficheiro',
    templateNote6: 'Guardar como formato .xlsx ou .csv',
    stockAvailabilityWarning: 'A disponibilidade real de stock será verificada na próxima página de finalização.',
    outOfStock: 'Esgotado',
    insufficientStock: 'Stock insuficiente: {available} disponível(eis), {requested} solicitado(s)',
  },
  orderExport: {
    export: 'Exportar Encomenda',
    exportOrder: 'Exportar Dados da Encomenda',
    exportAsCSV: 'Exportar como CSV',
    exportAsExcel: 'Exportar como Excel',
    exportForReorder: 'Exportar para Importação em Massa',
    detailed: 'Detalhes Completos',
    simpleFormat: 'Formato de Importação',
  },
};
